import { ReactNode, useLayoutEffect } from "react";
import { useSelector } from "react-redux";

interface EnvironmentGuardProps {
  children: ReactNode;
}

const HOST_BY_PREFIX: Record<string, string> = {
  uat: "mypeabody-test.peabody.org.uk",
  preprod: "pb-uks-preprod-dep-selfserve-fd.azurefd.net",
  test: "pb-uks-test-dep-selfserve-fd.azurefd.net",
};

const EnvironmentGuard = ({ children }: EnvironmentGuardProps) => {
  const instructionReferenceFromRedux = useSelector(
    (state: any) => state.userChoicesReducer?.instructionReferenceValue
  );

  useLayoutEffect(() => {
    const url = new URL(window.location.href);

    const reference =
      instructionReferenceFromRedux ||
      url.searchParams.get("instructionReference") ||
      url.searchParams.get("ref") ||
      "";

    const prefix = reference.trim().toLowerCase().split("_", 1)[0];
    const mappedHost = HOST_BY_PREFIX[prefix];

    // Only redirect when prefix maps to a known host.
    if (mappedHost && mappedHost !== url.hostname) {
      url.hostname = mappedHost;
      window.location.replace(url.toString());
    }
  }, [instructionReferenceFromRedux]);

  return <>{children}</>;
};

export default EnvironmentGuard;